import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/styles/index.css'
import InstantSearch from 'vue-instantsearch';

console.log('main')

import VueToast from 'vue-toast-notification';
// Import one of available themes
import 'vue-toast-notification/dist/theme-default.css';
import 'vue-toast-notification/dist/theme-sugar.css';

Vue.use(VueToast, {
  // One of the options
  position: 'bottom-right',
  dismissible: true
})

Vue.use(InstantSearch);

// Vue Croppa
import Croppa from 'vue-croppa';

Vue.use(Croppa);

import VueI18n from 'vue-i18n'
import VueCookie from 'vue-cookie'

Vue.use(VueI18n)
Vue.use(VueCookie)
// Google
import * as VueGoogleMaps from 'vue2-google-maps'

import VueGtag from "vue-gtag";

Vue.use(VueGtag, {
  config: { id: "UA-86299131-13" }
}, router);

import VueGeolocation from 'vue-browser-geolocation';
import i18n from './i18n'
// import { createProvider } from './vue-apollo'
Vue.use(VueGeolocation);

import iFrameResize from 'iframe-resizer/js/iframeResizer'

Vue.directive('resize', {
  bind: function (el, { value = {} }) {
    el.addEventListener('load', () => iFrameResize(value, el))
  }
})


Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAgWOoYMVFt3Uj501mcvYypJDmwjJn0C30",
    language: "es",
    libraries: "places, geocode"

  },

})


Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  //  apolloProvider: createProvider(),
  render: h => h(App)
  // mounted: () => document.dispatchEvent(new Event("x-app-rendered")),
}).$mount('#app')
